export var borderStyles = {
    solid: "solid",
    dashed: "dashed"
};
